export function shouldForceSetupServiceRefresh(): boolean {
  return process.env.WAKELOOP_SETUP_FORCE_SERVICE_REFRESH === "1";
}
